<template>
  <div>
    <div v-if="this.loaded && !this.isEditable">
      <NoAccess></NoAccess>
    </div>
    <div v-if="this.loaded && this.isEditable">
      <b-container>
        <div class="mt-5 pl-3 pr-3 pb-3 bg-white">
          <b-row class="pl-3 pr-3 pt-4">
            <h3 class="text-left">Edit the recipe</h3>
          </b-row>
          <hr />
          <b-row>
            <b-col class="my-container" cols-6>
              <b-form>
                <b-form-group
                  id="input-group-1"
                  label-align="left"
                  label-for="input-1"
                >
                  <label class="d-block text-left text-bold"
                    >Recipe title <span class="text-danger">*</span></label
                  >
                  <b-form-input placeholder="Enter a title" v-model="title">
                  </b-form-input>

                  <b-alert
                    dismissible
                    style="width: 100%"
                    v-model="emptyTitleAlert"
                    variant="danger"
                  >
                    You have to provide a title!
                  </b-alert>
                </b-form-group>

                <b-form-group>
                  <label class="d-block text-left text-bold"
                    >Description <span class="text-danger">*</span></label
                  >
                  <textarea
                    class="col-12 form-control textareaDescription"
                    placeholder="Enter a description"
                    v-model="description"
                  >
                  </textarea>

                  <b-alert
                    dismissible
                    style="width: 100%"
                    v-model="emptyDescriptionAlert"
                    variant="danger"
                  >
                    You have to provide a description!
                  </b-alert>
                </b-form-group>

                <!--              <b-form-group>-->
                <!--                <label class="d-block text-left text-bold">Image Resource <span class="text-danger">*</span></label>-->
                <!--                <b-form-input-->
                <!--                  @click="searchImage"-->
                <!--                  placeholder="Search for an image"-->
                <!--                  v-model="chosenImageId">-->
                <!--                </b-form-input>-->

                <!--                <b-alert dismissible style="width: 100%" v-model="emptyImageResourceAlert" variant="danger">-->
                <!--                  You have to provide an image resource!-->
                <!--                </b-alert>-->
                <!--              </b-form-group>-->

                <b-form-group class="text-left">
                  <label
                    title="Link to a website presenting the project"
                    v-b-tooltip.hover.bottom
                    >URL</label
                  >
                  <b-form-input
                    placeholder="Link to a website presenting the project"
                    v-model="url"
                  >
                  </b-form-input>
                </b-form-group>

                <b-form-group class="text-left">
                  <label
                    title="Some keywords that capture important aspects of the recipe"
                    v-b-tooltip.hover.bottom
                    >Keywords</label
                  >
                  <tags-input
                    :typeahead="true"
                    element-id="keywords"
                    placeholder="  Some keywords that capture important aspects of the recipe"
                    v-model="keywords"
                  >
                  </tags-input>
                  <p
                    class="text-left font-italic"
                    style="color: red; font-size: 14px"
                  >
                    * Press enter after each keyword.
                  </p>
                </b-form-group>

                <!--                <b-form-group class="text-left">-->
                <!--                  <label-->
                <!--                    title="Services and facilities that this organisation offers and can be useful for the organisation of participatory projects, e.g. meeting rooms, 3D printer etc"-->
                <!--                    v-b-tooltip.hover.bottom>Services</label>-->
                <!--                  <b-form-textarea-->
                <!--                    class="col-12 form-control"-->
                <!--                    placeholder="Services and facilities that this organisation offers and can be useful for the organisation of participatory projects, e.g. meeting rooms, 3D printer etc"-->
                <!--                    style="height: 90px"-->
                <!--                    v-model="services">-->
                <!--                  </b-form-textarea>-->
                <!--                </b-form-group>-->

                <b-form-group class="text-left">
                  <label
                    title="Pieces of practical advice, especially on matters whose importance is often not anticipated in advance"
                    v-b-tooltip.hover.bottom
                    >Tips
                  </label>
                  <b-form-textarea
                   style="height: 130px"
                    id="input-2"
                    placeholder="Pieces of practical advice, especially on matters whose importance is often not anticipated in advance"
                    v-model="tips"
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-form>
            </b-col>

            <b-col cols-6>
              <b-form>
                <b-form-group class="text-left">
                  <label
                    title="How long the execution of the recipe took/is expected to take in real time"
                    v-b-tooltip.hover.bottom
                    >Duration
                  </label>
                  <b-form-select :options="Duration" v-model="duration">
                  </b-form-select>
                </b-form-group>

                <b-form-group class="text-left">
                  <label
                    title="Number of participants addressed by the recipe"
                    v-b-tooltip.hover.bottom
                    >Number of participants</label
                  >
                  <b-form-select
                    :options="NumberOfParticipants"
                    id="input-2"
                    v-model="numberOfParticipants"
                  >
                  </b-form-select>
                </b-form-group>

                <b-form-group class="text-left">
                  <label
                    title="Cost for organising the recipe"
                    v-b-tooltip.hover.bottom
                    >Cost</label
                  >
                  <b-form-select :options="Cost" id="input-3" v-model="cost">
                  </b-form-select>
                </b-form-group>

                <b-container class="my-container">
                  <b-form-group>
                    <label class="d-block text-left text-bold"                    
                      >
                      <span title="Topics addressed by the project"
                    v-b-tooltip.hover.bottom>Areas of Focus</span>
                       <span class="text-danger">*</span> (Hold
                      <strong>Ctrl</strong> to select multiple values)</label
                    >
                    <b-row>
                      <b-col class="col-12">
                        <b-form-select
                          :options="FocusAreaOptions"
                          :select-size="11"
                          multiple
                          v-model="selectedFocusAreas"
                        >
                        </b-form-select>
                        <b-form-group
                          class="mt-4"
                          v-if="this.selectedFocusAreas.includes('Other')"
                        >
                          <label class="d-block text-left text-bold"
                            >Please specify</label
                          >
                          <b-form-input
                            placeholder="Enter the focus area of the recipe"
                            v-model="additionalFocusArea"
                          >
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <!--                    <b-col class="col-6">-->
                      <!--                      <b-form-checkbox-group-->
                      <!--                        :options="FocusAreaOptions2"-->
                      <!--                        v-model="selectedFocusAreas2">-->
                      <!--                      </b-form-checkbox-group>-->
                      <!--                    </b-col>-->
                    </b-row>
                  </b-form-group>

                  <b-alert
                    dismissible
                    style="width: 100%"
                    v-model="emptySelectedFocusAreas1Alert"
                    variant="danger"
                  >
                    You have to provide at least one focus area!
                  </b-alert>
                </b-container>
                <b-container>
                  <b-row >
                    <b-col cols="5">
                      <b-form-checkbox
                        align-self="left"
                        checked-value="true"
                        class="custom-control"
                        style="margin-left: -30px"
                        title="Everybody can see"
                        unchecked-value="false"
                        v-b-tooltip.hover.bottom
                        v-model="publicReadable"
                      >
                        Public
                      </b-form-checkbox>
                    </b-col>

                    <b-col cols="5">
                      <b-form-checkbox
                        align-self="start"
                        checked-value="true"
                        class="custom-control"
                        title="Whether the recipe describes a past completed project or is about a new or ongoing project idea"
                        unchecked-value="false"
                        v-b-tooltip.hover.bottom
                        v-model="implemented"
                      >
                        Completed
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-container>
              </b-form>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col class="text-left" cols="6">
              <label 
              title="Upload a new file that will appear as the recipe’s banner upon presentation. Providing this visual material will make your recipe more appealing."
                      v-b-tooltip.hover.bottom
              ><strong>Recipe banner</strong></label>
                           <!-- <p>Select an existing file or upload a new one for the Recipe banner</p>
              <p>Upload a new file for the Recipe banner</p> -->
              <b-form-group>
                <b-form-file
                  :state="Boolean(file)"
                  class="text-left mt-4"
                  drop-placeholder="Drop file here..."
                  placeholder="Browse your files..."
                  v-model="file"
                >
                </b-form-file>
              </b-form-group>
              <!--              <button @click="choseNew" class="btn bg-orange btn-sm">Upload new image</button>-->
              <!--              <button @click="choseExisting" class="btn bg-orange btn-sm">Choose existing image</button>-->
            </b-col>
            <b-col
              class="text-left"
              cols="6"
              v-if="!this.file && this.bannerUrl"
            >
              <label><strong>Current Image:</strong></label>
              <div>
                <img
                  :src="this.bannerUrl"
                  alt=""
                  style="width: auto; max-height: 300px"
                />
              </div>
              <div class="text-left mt-2">
                <p>
                  View the image
                  <a :href="this.bannerUrl" target="_blank">here</a>
                </p>
              </div>
            </b-col>
          </b-row>

          <!--          <b-row class="mt-2 mb-2" v-show="chooseExisting">-->
          <!--            <b-col cols="6">-->
          <!--              <b-form-group>-->
          <!--                <b-form-input-->
          <!--                  @click="searchImage"-->
          <!--                  placeholder="Search for an image"-->
          <!--                  v-model="chosenImageId">-->
          <!--                </b-form-input>-->
          <!--              </b-form-group>-->
          <!--            </b-col>-->
          <!--          </b-row>-->

          <!--          <b-row class="mt-2 mb-2" v-show="!chooseExisting">-->
          <!--            <b-col cols="6">-->
          <!--              &lt;!&ndash; add content  &ndash;&gt;-->
          <!--              <b-form-group>-->
          <!--                <b-form-file-->
          <!--                  :state="Boolean(file)"-->
          <!--                  class="text-left mt-4"-->
          <!--                  drop-placeholder="Drop file here..."-->
          <!--                  placeholder="Browse your files..."-->
          <!--                  v-model="file">-->
          <!--                </b-form-file>-->
          <!--              </b-form-group>-->
          <!--            </b-col>-->
          <!--          </b-row>-->

          <hr />

          <b-row>
            <b-col cols-12>
              <b-form>
                <b-row class="p-3">
                  <p><strong>Languages & Countries</strong></p>
                </b-row>
                <b-row>
                  <b-col class="text-left" cols="1">
                    <label
                      class="text-left"
                      title="Languages used for communication within the recipe"
                      v-b-tooltip.hover.bottom
                    >
                      Languages
                    </label>
                  </b-col>
                  <b-col cols="4">
                    <label class="text-left"
                      >Hold <strong>Ctrl</strong> to select multiple</label
                    >
                    <b-form-group label-align="left" label-for="input-24">
                      <b-form-select
                        :options="TargetGroupLanguage"
                        multiple
                        style="height: 210px"
                        v-model="languages"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mt-4"
                      v-if="languages.includes('Other')"
                    >
                      <label class="d-block text-left text-bold"
                        >Please specify</label
                      >
                      <b-form-input
                        placeholder="Enter the additional language"
                        v-model="additionalLanguage"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col class="text-left" cols="1">
                    <label
                      class="text-left"
                      title="Countries in which the recipe took/takes/will take place"
                      v-b-tooltip.hover.bottom
                    >
                      Countries
                    </label>
                  </b-col>
                  <b-col cols="4">
                    <label class="text-left"
                      >Hold <strong>Ctrl</strong> to select multiple</label
                    >
                    <b-form-group label-align="left" label-for="input-24">
                      <b-form-select
                        :options="TargetGroupCountry"
                        multiple
                        style="height: 210px"
                        v-model="countries"
                      >
                      </b-form-select>
                    </b-form-group>
                    <b-form-group
                      class="mt-4"
                      v-if="countries.includes('Other')"
                    >
                      <label class="d-block text-left text-bold"
                        >Please specify</label
                      >
                      <b-form-input
                        placeholder="Enter the additional country"
                        v-model="additionalCountry"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>

          <hr />

          <b-row>
            <b-col cols-12>
              <b-form>
                <!-- target groups -->
                <b-row class="p-3">
                  <p>
                    <span class="col-3 mr-5">
                      <strong
                        title="The main target groups and beneficiaries of the recipe"
                        v-b-tooltip.hover.bottom
                      >
                        Target Groups
                      </strong>
                    </span>
                    <span class="col-8">
                      <a
                        @click.prevent="addNewTargetGroupForm"
                        class="text-orange"
                        href="#"
                        >Add new Target group</a
                      >
                    </span>
                  </p>
                </b-row>
                <b-row>
                  <b-col cols-4>
                    <div
                      :key="index"
                      class="row my-container"
                      v-for="(TG, index) in targetGroup"
                    >
                      <b-col class="text-left" cols="2">
                        <label class="text-left"
                          >Target group {{ index + 1 }}
                        </label>
                      </b-col>
                      <b-col cols="4">
                        <b-form-group>
                          <label class="d-block text-left text-bold"
                            >Target group type<span class="text-danger">*</span>
                            (Hold <strong>Ctrl</strong> to select
                            multiple)</label
                          >
                          <b-form-select
                            :options="TargetGroupTypes"
                            multiple
                            :select-size="10"
                            title="Please select the type(s) that better describe your target group"
                            v-b-tooltip.hover.bottom
                            v-model="TG.type"
                          >
                          </b-form-select>
                        </b-form-group>
                        <b-form-group
                          class="mt-4"
                          v-if="targetGroup[index].type.includes('Other')"
                        >
                          <label class="d-block text-left text-bold"
                            >Please specify</label
                          >
                          <b-form-input
                            placeholder="Enter the additional target group"
                            v-model="additionalTargetGroup[index]"
                          >
                          </b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col cols="4">
                        <b-form-group label-align="left" label-for="input-24">
                          <textarea
                            class="col-12 form-control"
                            placeholder="Enter description"
                            style="height: 100px; margin-top: 32px"
                            v-model="TG.description"
                          >
                          </textarea>
                        </b-form-group>
                      </b-col>
                      <b-col class="mt-5" cols="1">
                        <span
                          @click="deleteTargetGroup(index)"
                          class="col-1 float-body"
                          style="cursor: pointer; color: red"
                          title="Delete"
                          v-b-tooltip.hover.bottom
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </b-col>
                    </div>
                  </b-col>
                </b-row>
                <hr />
                <!-- steps -->
                <b-row class="p-3">
                  <p>
                    <span class="col-3 mr-5"
                      ><strong
                        title="Activities that took/take/will take place as part of the recipe"
                        v-b-tooltip.hover.bottom
                        >Steps</strong
                      ></span
                    >
                    <span class="col-8">
                      <a
                        @click.prevent="addNewStepForm"
                        class="text-orange"
                        href="#"
                        >Add new step</a
                      >
                    </span>
                  </p>
                </b-row>
                <b-row class="p-3">
                  <b-col cols-12>
                    <div
                      :key="index"
                      class="col-12 row my-container"
                      v-for="(step, index) in steps"
                    >
                      <b-row class="col-12 my-container">
                        <b-col cols="2"><label>Step {{ index + 1 }} </label></b-col>
                        <b-col cols="4"><b-form-group >
                          <b-form-input
                            id="input-3"
                            placeholder="Enter step title"
                            v-model="step.title"
                          />
                        </b-form-group></b-col>
                        <b-col cols="4"> <b-form-group >
                          <textarea
                            class="col-12 form-control"
                            placeholder="Enter step description"
                            v-model="step.description"
                          />
                        </b-form-group></b-col>
                        <b-col cols="2"><span
                          class="col-1 float-body"
                          title="Add step underneath"
                          v-b-tooltip.hover.top
                        >
                          <font-awesome-icon
                            style="color: green; cursor: pointer"
                            @click="addNewStepUnderneath(index)"
                            icon="plus"
                          />
                        </span>
                        <span
                          class="col-1 float-body"
                          title="Delete step"
                          v-b-tooltip.hover.top
                        >
                          <font-awesome-icon
                            style="color: red; cursor: pointer"
                            @click="deleteStep(index)"
                            icon="trash-alt"
                          />
                        </span></b-col>
                      </b-row>
                      <br />
                    </div>
                  </b-col>
                </b-row>
                <hr />
                <!-- challenges -->
                <b-row class="p-3">
                  <p>
                    <span class="col-3 mr-5">
                      <strong
                        title="Main challenge encountered (or foreseen to encounter) and description of possible ways to address them, including helpful resources"
                        v-b-tooltip.hover.bottom
                        >Challenges
                      </strong>
                    </span>
                    <span class="col-8">
                      <a
                        @click.prevent="addNewChallengeForm"
                        class="text-orange"
                        href="#"
                        >Add new challenge</a
                      >
                    </span>
                  </p>
                </b-row>
                <b-row class="p-3">
                  <b-col cols-12>
                    <div
                      :key="index"
                      class="row my-container"
                      v-for="(challenge, index) in challenges"
                    >
                      <b-row class="col-12 my-container">

                        <b-col cols="2"><label>Challenge {{ index + 1 }} </label></b-col>
                        <b-col cols="4"> <b-form-group  >
                          <textarea
                            class="col-12 form-control"
                            placeholder="Briefly describe the challenge"
                            rows="2"
                            style="height: 120px"
                            v-model="challenge.description"
                          />
                        </b-form-group></b-col>
                        <b-col cols="4"> <b-form-group  >
                          <textarea
                            class="col-12 form-control"
                            placeholder="Briefly describe a way to address it"
                            rows="2"
                            style="height: 120px"
                            v-model="challenge.solution"
                          />
                        </b-form-group></b-col>
                        <b-col cols="2"><span
                          @click="deleteChallenge(index)"
                          class="col-1 float-body"
                          style="cursor: pointer; color: red"
                          title="Delete"
                          v-b-tooltip.hover.bottom
                        >
                          <font-awesome-icon icon="trash-alt"
                        /></span></b-col>
                      </b-row>
                      <br />
                    </div>
                  </b-col>
                </b-row>
                <hr />
                <!-- Collaborators -->
                <b-row class="text-left p-3">
                  <p>
                    <span
                      class="text-left col-3 mr-5"
                      title="The organisations that collaborated/need to collaborate for the implementation of the recipe."
                      v-b-tooltip.hover.bottom
                      ><strong>Collaborators</strong>
                    </span>
                  </p>
                  <p class="text-left container pl-3 font-italic">
                    You can either (a) search for an existing organisation and
                    add it as a collaborator for this recipe or (b) register a
                    new organisation or (c) just add the description of a
                    collaborator as part of the recipe description.
                  </p>
                </b-row>
                <b-row class="pl-4">
                  <div class="col-12 row my-container">
                    <b-row>
                      <b-col class="text-left" cols="5">
                        <p>
                          <strong
                            >(a) Search for an existing organisation and add it
                            as a collaborator for this recipe</strong
                          >
                        </p>
                      </b-col>
                      <b-col>or</b-col>
                      
                      <b-col class="text-left" cols="3">
                        <p>
                          <strong
                            >(b) Register a new organisation and add it as a
                            collaborator</strong
                          >
                        </p>
                      </b-col>
                      <!--                  <p><strong>(a) Search for an existing organisation and add it as a collaborator for this recipe or (b) Register a new organisation and add it as a collaborator</strong></p>-->
                      <b-col class="text-left ml-5" cols="3">
                        <b-button
                          @click="addNewCollaboratorForm"
                          class="btn bg-orange btn-sm"
                        >
                          <span
                            style="cursor: pointer; color: green"
                            title="Add new"
                          >
                            <font-awesome-icon icon="plus" />
                          </span>
                          Add new collaborator
                        </b-button>
                      </b-col>
                    </b-row>
                    <div
                      :key="index"
                      class="col-12 row my-container"
                      v-for="(collaborator, index) in collaboratorsWithId"
                    >
                      <label>Collaborator {{ index + 1 }}</label>
                      <b-form-group class="CollaboratorsAlign">
                        <b-form-input
                          @click="searchOrganisation(index)"
                          placeholder="Search collaborator"
                          type="text"
                          v-model="chosenCollaboratorName[index]"
                        >
                        </b-form-input>
                      </b-form-group>
                      <span>
                        <b-button
                          @click="modalOrgShow = !modalOrgShow"
                          class="btn bg-orange btn-sm"
                          style="
                            cursor: pointer;
                            margin-left: 65px;
                            margin-bottom: 0px;
                            color: red;
                          "
                          title="Register a new organisation to add it as a collaborator"
                          v-b-tooltip.hover.bottom
                          v-show="!chosenCollaboratorName[index]"
                        >
                          ... or create a new organisation
                        </b-button>
                        <b-modal
                          hide-footer
                          size="xl"
                          static
                          v-model="modalOrgShow"
                          ><CreateNewOrganization></CreateNewOrganization
                        ></b-modal>
                      </span>
                      <span
                        @click="deleteCollaborator(index)"
                        style="
                          cursor: pointer;
                          margin-left: 45px;
                          margin-bottom: 0px;
                          color: red;
                        "
                        title="Delete"
                        v-b-tooltip.hover.bottom
                      >
                        <font-awesome-icon icon="trash-alt" />
                      </span>
                    </div>
                  </div>
                </b-row>

                <b-row class="mt-4 pl-2">
                  <div class="col-12 row my-container">
                    <b-col class="text-left" cols="9">
                      <p>
                        <strong
                          >(c) Add the description of a collaborator as part of
                          the recipe description (no need to register it as an
                          organisation in the platform)</strong
                        >
                      </p>
                    </b-col>
                    <b-col class="text-left" cols="2">
                      <b-button
                        @click="addNewNonExistingCollaborator"
                        class="btn bg-orange btn-sm"
                      >
                        <span
                          style="cursor: pointer; color: green"
                          title="Add new"
                        >
                          <font-awesome-icon icon="plus" />
                        </span>
                        Add new
                      </b-button>
                      <!--                      <p class="pl-3"><a @click.prevent="addNewNonExistingCollaborator" class="text-orange" href="#">Add-->
                      <!--                      new</a></p>-->
                    </b-col>
                    <b-row
                      :key="index"
                      class="mt-3 col-12"
                      v-for="(collaborator, index) in collaborators"
                    >
                    <b-col cols="2"><label
                        class="pl-3"
                       
                        >{{ index + 1 }})
                      </label></b-col>
                    <b-col cols="4"> <b-form-input
                          placeholder="Enter the collaborator's name"
                          v-model="collaborators[index].name"
                           title="This collaborator is not going to be registered in the platform"
                        v-b-tooltip.hover.bottom
                        >
                        </b-form-input>
                        <select
                          class="mt-2 custom-select d-block w-100"
                          id="CollaboratorType"
                          v-model="collaborators[index].type"
                        >
                          <option disabled value="">Select type</option>
                          <option value="Central government">
                            Central government
                          </option>
                          <option value="Charity or foundation">
                            Charity or foundation
                          </option>
                          <option value="For-profit organisation">
                            For-profit organisation
                          </option>
                          <option value="GLAM">
                            GLAM (Galleries, Libraries, Archives, Museums)
                          </option>
                          <option value="Informal group or association">
                            Informal group or association
                          </option>
                          <option value="International body">
                            International body
                          </option>
                          <option value="Local government">
                            Local government
                          </option>
                          <option value="Non-Governmental Organisation">
                            Non-Governmental Organisation
                          </option>
                          <option value="Regional government">
                            Regional government
                          </option>
                          <option value="Religious institutions">
                            Religious institutions
                          </option>
                          <option value="School">School</option>
                          <option value="University or research institute">
                            University or research institute
                          </option>
                          <option value="Other">Other</option>
                        </select></b-col>
                    <b-col cols="4"><b-textarea
                          placeholder="Enter the collaborator's description"
                          style="height: 84px"
                          v-model="collaborators[index].description"
                        >
                        </b-textarea></b-col>
                    <b-col cols="2"><span class="mt-4">
                        <span
                          @click="deleteNonExistingCollaborator(index)"
                          class="ml-2"
                          style="cursor: pointer; color: red"
                          title="Delete"
                          v-b-tooltip.hover.bottom
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span>
                      </span></b-col>
                      
                      <!-- <b-col>
                       
                      </b-col>
                      <b-col>
                        
                      </b-col> -->
                      
                    </b-row>
                    <!--                  <span class="col-8">-->
                    <!--                    <a href="#" @click.prevent="addNewCollaboratorForm" class="text-orange">Add new collaborator</a>-->
                    <!--                  </span>-->
                  </div>
                </b-row>

                <hr />
                <!-- ingredients/recipes -->
                <!--                <p class="text-left">-->
                <!--                  <strong-->
                <!--                    title="Resources in different formats (images, documents, links to videos or websites) that are useful for the organisation of a project, e.g. training material, policies, past projects, digital cultural heritage objects, etc. You can either search to add existing resources as ingredients to this recipe or create new ones"-->
                <!--                    v-b-tooltip.hover.bottom>-->
                <!--                    Ingredients-->
                <!--                  </strong>-->
                <!--                </p>-->
                <!--                <b-row class="p-3">-->
                <!--                  <p>-->
                <!--                    <span class="col-3 mr-5"><strong>Recipes</strong></span>-->
                <!--                    <span class="col-8">-->
                <!--                  <a @click.prevent="addNewRecipeForm" class="text-orange" href="#">Add new recipe as ingredient</a>-->
                <!--                </span>-->
                <!--                  </p>-->
                <!--                </b-row>-->
                <!--                <b-row class="p-3">-->
                <!--                  <b-col cols-12>-->
                <!--                    <div :key="index" class="row my-container" v-for="(recipe,index)  in recipes">-->
                <!--                      <b-row class="col-12 my-container">-->
                <!--                        <label>Recipe {{index +1}}</label>-->
                <!--                        <b-form-group class="col-4">-->
                <!--                          <b-form-input-->
                <!--                            @click="searchIngredientRecipe(index)"-->
                <!--                            class="col-12 form-control"-->
                <!--                            placeholder="Search recipe"-->
                <!--                            type="text"-->
                <!--                            v-model="chosenIngRecipeName[index]">-->
                <!--                          </b-form-input>-->
                <!--                        </b-form-group>-->

                <!--                        <span-->
                <!--                          @click="deleteRecipe(index)"-->
                <!--                          class="col-1 float-body"-->
                <!--                          style="cursor:pointer; color: red;"-->
                <!--                          title="Delete">-->
                <!--                      <font-awesome-icon icon="trash-alt"/></span>-->
                <!--                      </b-row>-->
                <!--                    </div>-->
                <!--                  </b-col>-->
                <!--                </b-row>-->
                <!--                <hr>-->
                <!-- ingredients/resources -->
                <b-row class="p-3">
                  <p>
                    <span class="col-3 mr-5">
                      <strong
                        title="Resources in different formats (images, documents, links to videos or websites) that are useful for the organisation of a project, e.g. training material, policies, past projects, digital cultural heritage objects, etc. You can either search to add existing resources as ingredients to this recipe or create new ones"
                        v-b-tooltip.hover.bottom
                      >
                        Ingredients
                      </strong>
                    </span>
                    <span class="col-8">
                      <a
                        @click.prevent="addNewResourceForm"
                        class="text-orange"
                        href="#"
                        >Add new ingredient</a
                      >
                    </span>
                  </p>
                </b-row>
                <b-row class="p-3">
                  <b-col cols-12>
                    <div
                      :key="index"
                      class="row my-container"
                      v-for="(resource, index) in resources"
                    >
                      <b-row class="col-12 my-container">
                        <b-col cols="2"><label>Ingredient {{ index + 1 }}</label></b-col>
                        <b-col cols="4"><b-form-group >
                          <b-form-input
                            @click="searchIngredientResource(index)"
                            class="col-12 form-control"
                            placeholder="Search resource"
                            type="text"
                            v-model="chosenIngResourceName[index]"
                          >
                          </b-form-input>
                        </b-form-group></b-col>
                        <b-col cols="1"><span
                          @click="deleteResource(index)"
                          class="col-1 float-body"
                          style="cursor: pointer; color: red"
                          title="Delete"
                          v-b-tooltip.hover.bottom
                        >
                          <font-awesome-icon icon="trash-alt" />
                        </span></b-col>
                        <b-col cols="5"><span class="float-left">
                          <b-button
                            @click="modalResShow = !modalResShow"
                            class="btn bg-orange btn-sm"
                            title="Create new resource"
                            v-show="!chosenIngResourcesArray[index]"
                          >
                            ... or create a new ingredient
                          </b-button>
                          <b-modal hide-footer size="xl" v-model="modalResShow"
                            ><CreateNewResource></CreateNewResource
                          ></b-modal>
                        </span></b-col>
                      </b-row>
                    </div>
                  </b-col>
                </b-row>

                <hr />

                <b-row class="p-3">
                  <p>
                    <span class="col-3 mr-5">
                      <strong
                        title="Resources describing the results of the described project (e.g. photographs from events, links to digital exhibitions, evaluation reports,  etc). You can either search to add existing resources from the ingredients repository as outputs of this recipe or create new ones"
                        v-b-tooltip.hover.bottom
                        >Outputs
                      </strong>
                    </span>
                    <span class="col-8">
                      <a
                        @click.prevent="addNewOutcomeForm"
                        class="text-orange"
                        href="#"
                        >Add new output
                      </a>
                    </span>
                  </p>
                </b-row>
                <b-row class="p-3">
                  <b-col cols-12>
                    <div
                      :key="index"
                      class="col-12 row my-container"
                      v-for="(outcome, index) in outputs"
                    >
                      <b-row class="col-12 my-container">
                        <b-col cols="2"><label>Output {{ index + 1 }} </label></b-col>
                        <b-col cols="4"><b-form-group
                          class="widthTextAreaOutputs"
                          label-for="input-1"
                        >
                          <b-form-input
                            @click="searchOutcome(index)"
                            placeholder="Search for existing ingredients to add as relevant output"
                            type="text"
                            v-model="chosenOutcomeName[index]"
                          />
                        </b-form-group></b-col>
                        <b-col cols="4"><span 
                          @click.prevent="deleteOutcome(index)"
                            class="col-1 float-body"
                          style="cursor: pointer; color: red"
                          title="Delete"
                          v-b-tooltip.hover.bottom
                        >
                          <font-awesome-icon icon="trash-alt" size="1x" />
                        </span></b-col> 
                      </b-row>
                    </div>
                  </b-col>
                </b-row>
              </b-form>
            </b-col>
          </b-row>

          <hr />

          <div class="center">
            <!--General info Title-->
            <!-- Save -->
            <b-row>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="showDismissibleAlert"
                variant="danger"
              >
                You must fill in all the required fields!
              </b-alert>
            </b-row>
            <b-row class="p-3 mb-4">
              <div>
                <router-link :to="{ name: 'recipeView' }">
                  <b-button class="link">Cancel</b-button>
                </router-link>
                <button
                  @click="checkForm"
                  class="btn bg-orange"
                  style="margin: 0"
                  type="button"
                >
                  Save
                </button>
              </div>
            </b-row>
          </div>
        </div>
      </b-container>
    </div>
  </div>
</template>

<script>
import SearchPlugin from "../plugins/SearchPlugin";
import axios from "axios";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import NoAccess from "../components/NoAccess";
import CreateNewOrganization from "../components/organizations/CreateNewOrganization";
import CreateNewResource from "../components/resources/CreateNewResource";
// import { apiBaseUrl } from '../../config'

export default {
  beforeCreate: function () {
    axios
      .get("/recipe/" + this.$route.params.id, { withCredentials: true })
      .then((response) => {
        // The page has started fetching the data
        this.isEditable =
          response.data.rights === "OWN" || response.data.rights === "WRITE";
        this.loaded = true;

        // Single value data fetch and edit
        this.title = response.data.title;
        this.description = response.data.description;
        this.tips = response.data.tips;
        this.duration = response.data.duration;
        this.numberOfParticipants = response.data.numberOfParticipants;
        this.cost = response.data.cost;
        this.publicReadable = response.data.publicReadable;
        this.implemented = response.data.implemented;
        this.url = response.data.url;
        // this.services = response.data.services
        this.chosenImageId = response.data.imageResource;
        // this.contentLink = '/recipe/image/' + response.data.id

        // Banner fetch
        if (response.data.bannerUrl) {
          this.bannerUrl = response.data.bannerUrl;
        }

        // Languages fetch
        if (response.data.languages.includes("Other")) {
          let index = response.data.languages.indexOf("Other");
          for (let i = 0; i <= index; i++) {
            this.languages[i] = response.data.languages[i];
            if (response.data.languages[index + 1] !== "") {
              // If the last value is not empty (deleted)
              this.additionalLanguage = response.data.languages[index + 1];
            }
          }
        } else {
          this.languages = response.data.languages;
        }

        // Countries fetch
        if (response.data.countries.includes("Other")) {
          let index = response.data.countries.indexOf("Other");
          for (let i = 0; i <= index; i++) {
            this.countries[i] = response.data.countries[i];
            if (response.data.countries[index + 1] !== "") {
              // If the last value is not empty (deleted)
              this.additionalCountry = response.data.countries[index + 1];
            }
          }
        } else {
          this.countries = response.data.countries;
        }

        // Ingredients fetch
        if (response.data.ingredients) {
          for (let i = 0; i < response.data.ingredients.length; i++) {
            if (response.data.ingredients[i].recipe) {
              this.recipes.push(response.data.ingredients[i]);
              this.chosenIngRecipesArray.push({
                id: response.data.ingredients[i].recipe.id,
              });
              this.chosenIngRecipeName.push(
                response.data.ingredients[i].recipe.title
              );
            }
            if (response.data.ingredients[i].resource) {
              this.resources.push(response.data.ingredients[i]);
              this.chosenIngResourcesArray.push({
                id: response.data.ingredients[i].resource.id,
              });
              this.chosenIngResourceName.push(
                response.data.ingredients[i].resource.title
              );
            }
          }
        }

        // Outcomes fetch
        if (response.data.outputs) {
          for (let i = 0; i < response.data.outputs.length; i++) {
            this.outputs.push(response.data.outputs[i]);
            this.chosenOutcomesArray.push({
              id: response.data.outputs[i].resource.id,
            });
            this.chosenOutcomeName.push(
              response.data.outputs[i].resource.title
            );
          }
        }

        // Collaborators fetch
        if (
          response.data.collaboratorsWithId &&
          response.data.collaboratorsWithId.length >= 1
        ) {
          for (let i = 0; i < response.data.collaboratorsWithId.length; i++) {
            this.collaboratorsWithId.push(response.data.collaboratorsWithId[i]);
            this.resourceCollaboratorsArray.push(
              response.data.collaboratorsWithId[i]
            );
            this.chosenCollaboratorName.push(
              response.data.collaboratorsWithId[i].name
            );
            this.chosenCollaboratorType.push(
              response.data.collaboratorsWithId[i].type
            );
          }
        } else {
          this.collaboratorsWithId.push({});
          this.chosenCollaboratorName.push();
        }

        // Collaborators without ID fetch
        if (
          response.data.collaborators.length &&
          response.data.collaborators.length >= 1
        ) {
          this.collaborators = response.data.collaborators;
        } else {
          this.collaborators.push({});
        }

        // Steps fetch
        for (let d = 0; d < Object.keys(response.data).length; d++) {
          if (Object.keys(response.data)[d] === "steps") {
            this.steps = [];
            for (let i = 0; i < response.data.steps.length; i++) {
              this.steps.push({
                title: response.data.steps[i].title,
                description: response.data.steps[i].description,
              });
            }
          }
        }

        // Focus areas fetch
        for (let i = 0; i < response.data.areasOfFocus.length; i++) {
          if (response.data.areasOfFocus[i] === "Education") {
            this.selectedFocusAreas.push("Education");
          }
          if (response.data.areasOfFocus[i] === "Arts and heritage") {
            this.selectedFocusAreas.push("Arts and heritage");
          }
          if (response.data.areasOfFocus[i] === "Human rights") {
            this.selectedFocusAreas.push("Human rights");
          }
          if (response.data.areasOfFocus[i] === "Job placement/employment") {
            this.selectedFocusAreas.push("Job placement/employment");
          }
          if (response.data.areasOfFocus[i] === "Intercultural understanding") {
            this.selectedFocusAreas.push("Intercultural understanding");
          }
          if (
            response.data.areasOfFocus[i] === "Interreligious understanding"
          ) {
            this.selectedFocusAreas.push("Interreligious understanding");
          }
          if (response.data.areasOfFocus[i] === "Leisure and entertainment") {
            this.selectedFocusAreas.push("Leisure and entertainment");
          }
          if (response.data.areasOfFocus[i] === "Skills development") {
            this.selectedFocusAreas.push("Skills development");
          }
          if (response.data.areasOfFocus[i] === "Social inclusion") {
            this.selectedFocusAreas.push("Social inclusion");
          }
          if (response.data.areasOfFocus[i] === "Other") {
            this.selectedFocusAreas.push("Other");
            this.additionalFocusArea =
              response.data.areasOfFocus[response.data.areasOfFocus.length - 1];
          }
        }

        // Challenges fetch
        if (response.data.challenges) {
          for (let i = 0; i < response.data.challenges.length; i++) {
            this.challenges.push(response.data.challenges[i]);
          }
        }

        // Target Groups fetch
        if (response.data.targetGroup) {
          this.targetGroup = response.data.targetGroup;
          for (let i = 0; i < response.data.targetGroup.length; i++) {
            if (
              response.data.targetGroup[i].type[
                response.data.targetGroup[i].type.length - 1
              ] === "Other"
            ) {
              this.additionalTargetGroup[i] =
                response.data.targetGroup[i].type[
                  response.data.targetGroup[i].type.length - 1
                ];
            }
          }
        }

        // Keywords fetch
        for (let d = 0; d < Object.keys(response.data).length; d++) {
          if (Object.keys(response.data)[d] === "keywords") {
            for (let i = 0; i < response.data.keywords.length; i++) {
              this.keywords.push({
                key: response.data.keywords[i],
                value: response.data.keywords[i],
              });
            }
          }
        }
      });
  },

  data() {
    return {
      isEditable: false,
      chooseExisting: false,
      file: null,
      loaded: false,
      saveAction: false,

      // Open modal for new resource handler
      modalResShow: false,

      // Open modal for new organisation handler
      modalOrgShow: false,

      // Variable to define what type of data we are searching for
      searchSelector: "",

      // Collaborator search and addition variables
      chosenCollaboratorName: [],
      chosenCollaboratorType: [],
      resourceCollaborators: {},
      resourceCollaboratorsArray: [],

      // Outcome search and addition variables
      chosenOutcomeName: [],
      chosenOutcomesArray: [],
      chosenOutcomes: {},

      // Challenge search and addition variables
      chosenChallengeName: [],
      chosenChallengesArray: [],
      chosenChallenges: {},

      // Image search and addition variables
      chosenImageId: null,

      // Ingredients: Recipe search and addition variables
      chosenIngRecipeName: [],
      chosenIngRecipes: {},
      chosenIngRecipesArray: [],

      // Ingredients: Resource search and addition variables
      chosenIngResourceName: [],
      chosenIngResources: {},
      chosenIngResourcesArray: [],

      // Alert variables
      emptyTitleAlert: false,
      emptyDescriptionAlert: false,
      emptyImageResourceAlert: false,
      emptySelectedFocusAreas1Alert: false,
      emptyTargetTypeAlert: false,
      showDismissibleAlert: false,

      additionalFocusArea: "",
      additionalTargetGroup: [],
      languages: [],
      countries: [],
      additionalLanguage: "",
      additionalCountry: "",
      selectedFocusAreas: [], // Must be an array reference!
      selectedFocusAreas2: [], // Must be an array reference!
      FocusAreaOptions: [
        { text: "Arts and heritage", value: "Arts and heritage" },
        { text: "Community development", value: "Community development" },
        { text: "Education", value: "Education" },
        { text: "Human rights", value: "Human rights" },
        {
          text: "Intercultural understanding",
          value: "Intercultural understanding",
        },
        {
          text: "Interreligious understanding",
          value: "Interreligious understanding",
        },
        { text: "Job placement/employment", value: "Job placement/employment" },
        {
          text: "Leisure and entertainment",
          value: "Leisure and entertainment",
        },
        { text: "Skills development", value: "Skills development" },
        { text: "Social inclusion", value: "Social inclusion" },
        { text: "Other", value: "Other" },
      ],
      // FocusAreaOptions2: [
      //   {text: 'Job placement/employment', value: 'Job placement/employment'},
      //   {text: 'Leisure and entertainment', value: 'Leisure and entertainment'},
      //   {text: 'Skills development', value: 'Skills development'},
      //   {text: 'Social inclusion', value: 'Social inclusion'},
      //   {text: 'Other', value: 'Other'}],
      Duration: [
        { text: "", value: null },
        { text: "Short (1-6 months)", value: "Short (1-6 months)" },
        { text: "Medium (6-12 months)", value: "Medium (6-12 months)" },
        { text: "Long (1–3 years)", value: "(1–3 years)" },
        { text: "Very long (3+ years)", value: "Very long (3+ years)" },
      ],
      NumberOfParticipants: [
        { text: "", value: null },
        { text: "Small (under 10)", value: "Small (under 10)" },
        { text: "Medium (10-20)", value: "Medium (10-20)" },
        { text: "Large (20-50)", value: "Large (20-50)" },
        { text: "Very large (over 50)", value: "Very large (over 50)" },
      ],
      Cost: [
        { text: "", value: null },
        { text: "Basic expenses", value: "Basic expenses" },
        {
          text: "Small investment (e.g., organisation budget)",
          value: "Small investment (e.g., organisation budget)",
        },
        {
          text: "Medium investment (e.g., regional grant)",
          value: "Medium investment (e.g., regional grant)",
        },
        {
          text: "Large investment (e.g., national grant)",
          value: "Large investment (e.g., national grant)",
        },
        {
          text: "Very large investment (e.g., European grant)",
          value: "Very large investment (e.g., European grant)",
        },
      ],
      publicReadable: false,
      implemented: false,
      TargetGroupTypes: [
        // {text: 'Select target group type', value: ''},
        {
          text: "Disadvantaged or vulnerable groups",
          value: "Disadvantaged or vulnerable groups",
        },
        { text: "Elderly people", value: "Elderly people" },
        { text: "LGBTQI+", value: "LGBTQI+" },
        { text: "Migrants", value: "Migrants" },
        { text: "Minorities", value: "Minorities" },
        {
          text: "Refugees and asylum seekers",
          value: "Refugees and asylum seekers",
        },
        { text: "Unemployed", value: "Unemployed" },
        { text: "Women", value: "Women" },
        { text: "Youth", value: "Youth" },
        { text: "Other", value: "Other" },
      ],
      TargetGroupLanguage: [
        // {text: 'Select target group language', value: '', disabled: true},
        { text: "Arabic", value: "Arabic" },
        { text: "Chinese", value: "Chinese" },
        // {text: 'Dari', value: 'Dari'},
        { text: "English", value: "English" },
        { text: "Finnish", value: "Finnish" },
        { text: "French", value: "French" },
        { text: "German", value: "German" },
        { text: "Greek", value: "Greek" },
        // {text: 'Hindi', value: 'Hindi'},
        { text: "Italian", value: "Italian" },
        { text: "Spanish", value: "Spanish" },
        // {text: 'Russian', value: 'Russian'},
        // {text: 'Ukrainian', value: 'Ukrainian'},
        { text: "Other (specify)", value: "Other" },
      ],
      TargetGroupCountry: [
        // {text: 'Select target group country', value: ''},
        { text: "Germany", value: "Germany" },
        { text: "Greece", value: "Greece" },
        { text: "Finland", value: "Finland" },
        { text: "Italy", value: "Italy" },
        // {text: 'India', value: 'India'},
        // {text: 'Libya', value: 'Libya'},
        { text: "Netherlands", value: "Netherlands" },
        // {text: 'Pakistan', value: 'Pakistan'},
        // {text: 'Russia', value: 'Russia'},
        { text: "Spain", value: "Spain" },
        // {text: 'Syria', value: 'Syria'},
        // {text: 'Ukraine', value: 'Ukraine'},
        { text: "United Kingdom", value: "United Kingdom" },
        { text: "Other (specify)", value: "Other" },
      ],
      // single values  Gen Info
      title: "",
      description: "",
      imageResource: 0,
      tips: "",
      keywords: [],
      // services: '',
      duration: "",
      cost: "",
      numberOfParticipants: "",
      challenges: [],
      steps: [{ title: "", description: "" }],
      collaboratorsWithId: [],
      recipes: [],
      resources: [],
      targetGroup: [{ type: "", description: "" }],
      outputs: [],
      url: "",
      collaborators: [],
    };
  },
  created() {
    eventBus.$on("hideModal", (data) => {
      this.modalResShow = data;
    });
    eventBus.$on("resourceTitle", (resourceTitle) => {
      this.chosenIngResourceName.push(resourceTitle);
    });
    eventBus.$on("resourceId", (resourceId) => {
      this.chosenIngResources["id"] = resourceId;
      this.chosenIngResourcesArray.push(this.chosenIngResources);
      this.chosenIngResources = {};
    });
    eventBus.$on("hideOrgModal", (hideOrgModal) => {
      this.modalOrgShow = hideOrgModal;
    });
    eventBus.$on("organizationTitle", (organizationTitle) => {
      this.chosenCollaboratorName.push(organizationTitle);
    });
    eventBus.$on("organizationId", (organizationId) => {
      this.resourceCollaborators["id"] = organizationId;
      this.resourceCollaboratorsArray.push(this.resourceCollaborators);
      this.resourceCollaborators = {};
    });
  },
  components: {
    NoAccess,
    CreateNewOrganization,
    CreateNewResource,
  },
  watch: {
    $route(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to);
      }
    },
    chosenCollaboratorName: function () {
      return this.chosenCollaboratorName;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      !this.saveAction &&
      this.loaded &&
      this.isEditable &&
      this.authenticatedUser
    ) {
      this.boxOne = "";
      this.$bvModal
        .msgBoxConfirm(
          "Are you sure you want to leave without saving? If you do, all your work will be lost.",
          {
            title: "Warning",
            okVariant: "danger",
          }
        )
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            next();
          } else {
            next(false);
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    FocusM() {
      let FocusM = this.selectedFocusAreas;
      return FocusM;
    },
    NewKeywordsArray() {
      let NewKeywordsArray = [];
      for (let i = 0; i < this.keywords.length; i++) {
        NewKeywordsArray.push(this.keywords[i].value);
      }
      return NewKeywordsArray;
    },
    IngredientsM() {
      let IngredientsM = [];
      for (let i = 0; i < this.recipes.length; i++) {
        // IngredientsM.push({recipe: this.recipes[i]})
        IngredientsM.push({ recipe: this.chosenIngRecipesArray[i] });
      }
      for (let i = 0; i < this.resources.length; i++) {
        // IngredientsM.push({resource: this.resources[i]})
        IngredientsM.push({ resource: this.chosenIngResourcesArray[i] });
      }
      return IngredientsM;
    },
    TargetGroupM() {
      let TargetGroupM = [];
      TargetGroupM = this.targetGroup;
      return TargetGroupM;
    },
    ImageResourceM() {
      let ImageResourceM = parseInt(this.imageResource, 10);
      return ImageResourceM;
    },
    ChallengesM() {
      let ChallengesM = [];
      for (let u = 0; u < this.challenges.length; u++) {
        // let resources = [{'id': this.chosenChallengesArray[u].id}]
        ChallengesM.push({
          description: this.challenges[u].description,
          solution: this.challenges[u].solution,
          // resources: resources
        });
      }
      return ChallengesM;
    },
  },
  beforeMount() {
    SearchPlugin.event.$on("updateterm", this.changeTerm);
    SearchPlugin.event.$on("showView", this.showView);
  },
  methods: {
    choseExisting() {
      // If the user has chosen an existing file after uploading a new one, clear the new one and keep the existing one
      this.chooseExisting = true;
      // this.file = null
    },
    choseNew() {
      // If the user has uploaded a file after choosing an existing file, clear the chosen one and keep the new one
      this.chooseExisting = false;
      // this.chosenImageId = null
    },
    searchOrganisation(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedOrganisation";
      this.collaboratorPosition = index;
      this.searchCategory("Organisations");
    },
    searchOutcome(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedOutcome";
      this.outcomePosition = index;
      this.searchTerm("", "Ingredients");
    },
    searchChallenge(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedChallenge";
      this.challengePosition = index;
      this.searchTerm("", "Ingredients");
    },
    searchImage() {
      this.searchSelector = "searchedImage";
      this.searchTerm("", "Ingredients");
    },
    searchIngredientRecipe(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedIngredientRecipe";
      this.ingRecipePosition = index;
      this.searchTerm("", "Recipes");
    },
    searchIngredientResource(index) {
      eventBus.$emit("forgetGlobalSearch", null);
      this.searchSelector = "searchedIngredientResource";
      this.ingResourcePosition = index;
      this.searchTerm("", "Ingredients");
    },
    checkForm() {
      this.emptyTitleAlert = false;
      this.emptyDescriptionAlert = false;
      this.emptyImageResourceAlert = false;
      this.emptySelectedFocusAreas1Alert = false;
      this.emptyTargetTypeAlert = false;
      this.showDismissibleAlert = false;

      if (
        this.selectedFocusAreas.includes("Other") &&
        this.FocusM[this.FocusM.length - 1] !== this.additionalFocusArea
      ) {
        this.FocusM.push(this.additionalFocusArea);
      }

      for (let i = 0; i < this.targetGroup.length; i++) {
        if (
          this.targetGroup[i].type.includes("Other") &&
          this.targetGroup[i].type[this.targetGroup[i].type.length] !==
            this.additionalTargetGroup[i]
        ) {
          this.targetGroup[i].type.splice(
            this.targetGroup[i].type.length - 1,
            1,
            this.additionalTargetGroup[i]
          );
        }
      }

      if (
        this.languages.includes("Other") &&
        this.languages[this.languages.length - 2] !== "Other" &&
        this.additionalLanguage &&
        this.additionalLanguage !== this.languages[this.languages.length - 1]
      ) {
        this.languages.push(this.additionalLanguage);
      } else if (
        this.languages[this.languages.length - 2] === "Other" &&
        this.additionalLanguage !== this.languages[this.languages.length - 1] &&
        this.additionalLanguage
      ) {
        this.languages.splice(
          this.languages.length - 1,
          1,
          this.additionalLanguage
        );
      }

      if (
        this.countries.includes("Other") &&
        this.countries[this.countries.length - 2] !== "Other" &&
        this.additionalCountry &&
        this.additionalCountry !== this.countries[this.countries.length - 1]
      ) {
        this.countries.push(this.additionalCountry);
      } else if (
        this.countries[this.countries.length - 2] === "Other" &&
        this.additionalCountry !== this.countries[this.countries.length - 1] &&
        this.additionalCountry
      ) {
        this.countries.splice(
          this.countries.length - 1,
          1,
          this.additionalCountry
        );
      }

      for (let i = 0; i < this.collaborators.length; i++) {
        if (!this.collaborators[i].name && !this.collaborators[i].description) {
          this.collaborators.splice(i, 1);
          i--;
        }
      }

      if (this.file) {
        // If the user has uploaded a file after choosing an existing file, clear the chosen one and keep the new one
        this.chosenImageId = null;
      }
      if (this.chosenImageId) {
        // If the user has chosen an existing file after uploading a new one, clear the new one and keep the existing one
        this.file = null;
      }

      // check if all required fields are filled
      if (
        !this.title ||
        !this.description ||
        this.selectedFocusAreas.length === 0
      ) {
        this.showDismissibleAlert = true;
        if (!this.title) {
          this.emptyTitleAlert = true;
        }
        if (!this.description) {
          this.emptyDescriptionAlert = true;
        }
        if (this.FocusM.length === 0) {
          this.emptySelectedFocusAreas1Alert = true;
        }
      } else {
        this.SendUserDataToAPI();
      }
    },
    deleteTargetGroup(index) {
      this.targetGroup.splice(index, 1);
    },
    deleteChallenge(index) {
      this.challenges.splice(index, 1);
      this.chosenChallengeName.splice(index, 1);
      this.challenges.splice(index, 1);
    },
    deleteStep(index) {
      this.steps.splice(index, 1);
    },
    addNewStepUnderneath(index) {
      this.steps.splice(index + 1, 0, { title: "", description: "" });
    },
    deleteCollaborator(index) {
      this.resourceCollaboratorsArray.splice(index, 1);
      this.chosenCollaboratorName.splice(index, 1);
      this.chosenCollaboratorType.splice(index, 1);
      this.collaboratorsWithId.splice(index, 1);
    },
    deleteNonExistingCollaborator(index) {
      this.collaborators.splice(index, 1);
    },
    deleteOutcome(index) {
      this.outputs.splice(index, 1);
      this.chosenOutcomesArray.splice(index, 1);
      this.chosenOutcomeName.splice(index, 1);
    },
    deleteRecipe(index) {
      this.recipes.splice(index, 1);
      this.chosenIngRecipesArray.splice(index, 1);
      this.chosenIngRecipeName.splice(index, 1);
    },
    deleteResource(index) {
      this.resources.splice(index, 1);
      this.chosenIngResourcesArray.splice(index, 1);
      this.chosenIngResourceName.splice(index, 1);
    },
    addNewCollaboratorForm() {
      this.collaboratorsWithId.push({});
    },
    addNewNonExistingCollaborator() {
      this.collaborators.push({
        type: "GLAM (Galleries, Libraries, Archives, Museums)",
      });
    },
    addNewOutcomeForm() {
      this.outputs.push({});
    },
    addNewTargetGroupForm() {
      this.targetGroup.push({ type: "", description: "" });
    },
    addNewStepForm() {
      this.steps.push({ title: "", description: "" });
    },
    addNewRecipeForm() {
      this.recipes.push({ id: 0 });
    },
    addNewChallengeForm() {
      this.challenges.push({ description: "", solution: "", resources: "" });
    },
    addNewResourceForm() {
      this.resources.push({ id: 0 });
    },
    showMsgSuccess() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Your recipe has been successfully updated.", {
          okVariant: "success",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            this.$router.push({ name: "recipeView" });
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgFail() {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Something went wrong. Please try again.", {
          okVariant: "danger",
        })
        .then((value) => {
          this.boxOne = value;
          if (this.boxOne) {
            // window.location.reload()
          } else {
          }
        });
      // .catch(error => {
      //   alert('An error occurred! Please refresh the page.' + error)
      // })
    },
    showMsgChallengesSteps() {
      if (
        !this.challengesStepsWarning &&
        this.steps[0].title === "" &&
        this.ChallengesM.length < 1
      ) {
        this.boxOne = "";
        this.$bvModal
          .msgBoxConfirm(
            "You have not entered any Steps or Challenges for your Recipe. Are you sure you wish to proceed?",
            {
              okVariant: "info",
            }
          )
          .then((value) => {
            this.boxOne = value;
            if (this.boxOne) {
              this.challengesStepsWarning = true;
              this.registerRecipe();
            } else {
              this.contactWarning = true;
            }
          });
        // .catch(error => {
        //   alert('An error occurred! Please refresh the page.' + error)
        // })
      } else {
        this.registerRecipe();
      }
    },
    registerRecipe() {
      this.saveAction = true;
      let CompletedRecipeFormData = "";
      CompletedRecipeFormData = {
        title: this.title,
        description: this.description,
        imageResource: this.chosenImageId,
        metadataLanguage: "string",
        tips: this.tips,
        keywords: this.NewKeywordsArray,
        // services: this.services,
        duration: this.duration,
        cost: this.cost,
        numberOfParticipants: this.numberOfParticipants,
        outputs: this.chosenOutcomesArray,
        publicReadable: this.publicReadable,
        implemented: this.implemented,
        areasOfFocus: this.FocusM,
        url: this.url,
        targetGroup: this.TargetGroupM,
        challenges: this.ChallengesM,
        steps: this.steps,
        collaboratorsWithId: this.resourceCollaboratorsArray,
        ingredients: this.IngredientsM,
        collaborators: this.collaborators,
        languages: this.languages,
        countries: this.countries,
      };

      if (!this.tips) {
        delete CompletedRecipeFormData.tips;
      }
      if (this.steps.length === 0) {
        delete CompletedRecipeFormData.steps;
      }
      if (this.steps.length === 1) {
        if (this.steps[0].title === "" && this.steps[0].description === "") {
          delete CompletedRecipeFormData.steps;
        }
      }
      if (!this.keywords[0]) {
        delete CompletedRecipeFormData.keywords;
      }
      if (!this.challenges[0]) {
        delete CompletedRecipeFormData.challenges;
      }
      if (!this.duration) {
        delete CompletedRecipeFormData.duration;
      }
      if (!this.cost) {
        delete CompletedRecipeFormData.cost;
      }
      if (!this.numberOfParticipants) {
        delete CompletedRecipeFormData.numberOfParticipants;
      }
      if (this.FocusM.length === 0) {
        delete CompletedRecipeFormData.areasOfFocus;
      }
      if (this.IngredientsM.length === 0) {
        delete CompletedRecipeFormData.ingredients;
      }
      if (this.targetGroup.length === 0) {
        delete CompletedRecipeFormData.targetGroup;
      }
      if (this.targetGroup.length === 1) {
        if (this.targetGroup[0].type === "") {
          delete CompletedRecipeFormData.targetGroup;
        }
      }
      axios
        .post(
          "/recipe/" + this.$route.params.id,
          CompletedRecipeFormData,
          { withCredentials: true },
          { headers: { "Content-Type": "application/json" } }
        )
        .then((recipe) => {
          if (recipe) {
            if (this.file !== null) {
              // console.log(recipe.data)
              let formData = new FormData();
              formData.append("file", this.file);
              let params = { id: recipe.data.id, file: formData };
              this.$store
                .dispatch("uploadRecipeBanner", params)
                .then((data) => {
                  this.showMsgSuccess();
                })
                .catch((error) => {
                  console.info(error);
                  this.showMsgFail();
                });
            } else {
              this.showMsgSuccess();
            }
          } else {
            this.showMsgFail();
          }
        })
        .catch((error) => {
          console.info(error);
          this.showMsgFail();
        });
    },
    SendUserDataToAPI() {
      if (this.targetGroup.length > 0) {
        let a = null;
        for (let i = 0; i < this.targetGroup.length; i++) {
          if (
            this.targetGroup[i].type === "" &&
            this.targetGroup[i].description !== ""
          ) {
            this.emptyTargetTypeAlert = true;
            window.alert(
              "You cannot create target without specifying its type"
            );
            // break
          } else a = a + 1;
        }

        if (this.targetGroup.length === a) {
          this.showMsgChallengesSteps();
        }
      }
      if (this.targetGroup.length === 0) {
        this.showMsgChallengesSteps();
      }
    },

    changeTerm(val) {
      this.sTerm = val;
    },
    ConfirmOk() {
      this.$router.push({ name: "recipes" });
    },
    showAll: function (token) {
      this.$search.searchNow();
    },
    showSearch: function () {
      this.$search.toggleSearch();
    },
    initOrg: function () {
      this.organisation = {};
    },
    initOutcome: function () {
      this.outcome = {};
    },
    initChallenge: function () {
      this.challenge = {};
    },
    initImage: function () {
      this.image = {};
    },
    initIngRecipe: function () {
      this.ingRecipe = {};
    },
    initIngResource: function () {
      this.ingResource = {};
    },
    showView: function (event) {
      if (this.searchSelector === "searchedOrganisation") {
        this.$store
          .dispatch("getOrganizationEntity", event.detail.id)
          .then((data) => {
            this.initOrg();
            this.organisation = data;
            if (
              this.resourceCollaboratorsArray[this.collaboratorPosition] == null
            ) {
              this.chosenCollaboratorName.push(this.organisation.name);
              this.chosenCollaboratorType.push(this.organisation.type);
              this.resourceCollaborators["id"] = event.detail.id;
              this.resourceCollaboratorsArray.push(this.resourceCollaborators);
              this.resourceCollaborators = {};
            } else {
              this.resourceCollaboratorsArray.splice(
                this.collaboratorPosition,
                1,
                this.resourceCollaborators
              );
              this.chosenCollaboratorName.splice(
                this.collaboratorPosition,
                1,
                this.organisation.name
              );
              this.chosenCollaboratorType.splice(
                this.collaboratorPosition,
                1,
                this.organisation.type
              );
              this.resourceCollaborators["id"] = event.detail.id;
              // this.resourceCollaboratorsArray.push(this.resourceCollaborators)
              this.resourceCollaborators = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedOutcome") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initOutcome();
            this.outcome = response;
            if (this.chosenOutcomesArray[this.outcomePosition] == null) {
              this.chosenOutcomeName.push(this.outcome.title);
              this.chosenOutcomesArray.push({ id: event.detail.id });
              this.chosenOutcomes = {};
            } else {
              this.chosenOutcomeName.splice(
                this.outcomePosition,
                1,
                this.outcome.title
              );
              this.chosenOutcomesArray.splice(this.outcomePosition, 1, {
                id: event.detail.id,
              });
              this.chosenOutcomes = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedChallenge") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initChallenge();
            this.challenge = response;
            if (this.chosenChallengesArray[this.challengePosition] == null) {
              this.chosenChallengeName.push(this.challenge.title);
              this.chosenChallengesArray.push(event.detail.id);
              this.chosenChallenges = {};
            } else {
              this.chosenChallengeName.splice(
                this.challengePosition,
                1,
                this.challenge.title
              );
              this.chosenChallengesArray.splice(
                this.challengePosition,
                1,
                response
              );
              this.chosenChallenges = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedImage") {
        this.chosenImageId = event.detail.id;
      } else if (this.searchSelector === "searchedIngredientRecipe") {
        this.$store
          .dispatch("getRecipeEntity", event.detail.id)
          .then((data) => {
            this.initIngRecipe();
            this.ingRecipe = data;
            if (this.chosenIngRecipesArray[this.ingRecipePosition] == null) {
              this.chosenIngRecipeName.push(this.ingRecipe.title);
              this.chosenIngRecipes["id"] = event.detail.id;
              this.chosenIngRecipesArray.push(this.chosenIngRecipes);
              this.chosenIngRecipes = {};
            } else {
              this.chosenIngRecipesArray.splice(this.ingRecipePosition, 1);
              this.chosenIngRecipeName.splice(
                this.ingRecipePosition,
                1,
                this.ingRecipe.title
              );
              this.chosenIngRecipes["id"] = event.detail.id;
              this.chosenIngRecipesArray.push(this.chosenIngRecipes);
              this.chosenIngRecipes = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      } else if (this.searchSelector === "searchedIngredientResource") {
        this.$store
          .dispatch("getResourceEntity", event.detail.id)
          .then((response) => {
            this.initIngResource();
            this.ingResource = response;
            if (
              this.chosenIngResourcesArray[this.ingResourcePosition] == null
            ) {
              this.chosenIngResourceName.push(this.ingResource.title);
              this.chosenIngResources["id"] = event.detail.id;
              this.chosenIngResourcesArray.push(this.chosenIngResources);
              this.chosenIngResources = {};
            } else {
              this.chosenIngResourcesArray.splice(this.challengePosition, 1);
              this.chosenIngResourceName.splice(
                this.challengePosition,
                1,
                this.ingResource.title
              );
              this.chosenIngResources["id"] = event.detail.id;
              this.chosenIngResourcesArray.push(this.chosenIngResources);
              this.chosenIngResources = {};
            }
          })
          .catch((error) => {
            console.info(error);
          });
      }
    },
    searchCategory: function (cat_type, token) {
      this.$search.searchNow({
        resulttype: cat_type,
        token: token,
      });
    },
    searchTerm: function (term, resulttype, token) {
      this.$search.searchNow({
        term: term,
        resulttype: resulttype,
        token: token,
      });
    },
  },
};
</script>

<style scoped>

.textareaDescription {
  height: 125px;
}

.height2 {
  height: 70px;
}
</style>

<style>
.custom-control {
  float: left;
  width: 100%;
}

.widthTextAreaOutputs {
  width: 450px;
  margin-left: 10px;
}

.CollaboratorsAlign {
  width: 280px;
  margin-left: 20px;
}

.CollaboratorsAlign2 {
  width: 280px;
  margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/RecipeEdit.vue